import React from "react";
import "../EventGallery.css";

const Daytwo2025 = () => {
  const images = [
    "https://cloud.hoverbusinessservices.com/aiifa/media/past-events/2025/day-2/1.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/2.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/3.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/4.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/5.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/6.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/7.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/8.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/9.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/10.jpeg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/11.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/12.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/13.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/14.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/15.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/16.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/17.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/18.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/19.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/20.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/21.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/22.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/23.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/24.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/25.JPG",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2025/day-2/26.JPG",
    
  ];

  return (
    <div className="event-gallery-container">
      <h2 className="event-gallery-title">Event 2025 Day 2</h2>
      <div className="event-gallery-grid">
        {images.map((img, index) => (
          <div key={index} className="event-gallery-card">
            <img src={img} alt={`Event ${index + 1}`} />
          </div> 
        ))}
      </div>  
    </div>
  );
};

export default Daytwo2025;